import ConfigField from '../ConfigField';
import { NODE_CONFIG_FIELDS } from '../../../constants';

export default function GetMembersConfig({ data, onChange }) {
  const fields = NODE_CONFIG_FIELDS.wallettwo_get_members;

  return (
    <div className="space-y-4">
      {fields.map((field) => (
        <div key={field.key}>
          <label className="block text-xs font-medium text-gray-600 mb-1.5">{field.label}</label>
          <ConfigField field={field} value={data[field.key]} onChange={(v) => onChange(field.key, v)} allData={data} onChangeField={onChange} />
        </div>
      ))}
      <div className="p-3 bg-cyan-50 border border-cyan-200 rounded-lg">
        <p className="text-xs text-cyan-700">
          Returns a list of members. Connect to a <strong>For Each</strong> node to iterate over them and perform actions on each member.
        </p>
      </div>
    </div>
  );
}
